// extracted by mini-css-extract-plugin
export default {"banner":"style_banner__uqSb1","bannerIconWrapper":"style_bannerIconWrapper__vFIOV","bannerTextWrapperCurrent":"style_bannerTextWrapperCurrent__LELhs","title":"style_title__mCbfE"};